// Internal Imports
import { get, post, deleteApi } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";
import { readDataFromLocalStorage } from "../../utils/globalUtils";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const fetchCrmDetails = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.CRM}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchCrmAllUsers = crmType =>
  new Promise((resolve, reject) => {
    get(`${APIS.CRM_OAUTH_USERS}?crm=${crmType}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchCrmDetailsByType = type =>
  new Promise((resolve, reject) => {
    get(`${APIS.CRM_CONFIG}?crm_type=${type.toUpperCase()}`)
      .then(response => {
        // console.debug(response);
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postCRMConfigData = configData =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM}`, configData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchCrmUserDetails = crm =>
  new Promise((resolve, reject) => {
    get(`${APIS.CRM_USER}/${crm}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchAllCrmUserDetails = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.CRM_USER_CONFIGS}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postCRMUserConfigData = configData =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_USER_CONFIGS}`, configData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postCRMCallback = (params, type) =>
  new Promise((resolve, reject) => {
    // for SF
    let url = `${APIS.CRM_CALLBACK}?${params}&crm=${type}`;
    if (type && type === "BOX") {
      url = `${APIS.CRM_OAUTH}?code=${params}&crm=${type}`;
    }
    post(url)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postCRMUserCallback = params =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_USER_CALLBACK}?${params}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMUsers = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/users`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMAccounts = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/accounts`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMContacts = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/contacts`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMOppStages = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/oppstages`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMOpportunities = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/opportunities`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMProductFamilies = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/categories`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncCRMProducts = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.CRM_SYNC}/products`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const syncDocSign = configData =>
  new Promise((resolve, reject) => {
    post(`${APIS.SYNC_DOC_SIGN}`, configData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchRedirectURL = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.GET_REDIRECT_URL}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const disconnectDocuSign = () =>
  new Promise((resolve, reject) => {
    post(`${APIS.DISSCONNECT_DOCU_SIGN}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchZapierKey = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ZAPIER_KEY}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchZapierKeyForOrg = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ZAPIER_KEY_BASED_ON_ORG}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const disconnectCRMService = type =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.CRM_CONFIG}?crm_type=${type}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `integrationServices => disconnectCRMService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const disconnectCRMUserService = type =>
  new Promise((resolve, reject) => {
    const user = readDataFromLocalStorage("revvsalesUser");
    const payload = {
      user_id: user.id,
      crm_type: type,
    };
    deleteApi(`${APIS.CRM_CONFIG}/user`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `integrationServices => disconnectCRMService => Error : ${error}`,
        );
        reject(error);
      });
  });
